import { WaiterDeliveryAlertWppContainer } from "./styles";
import WaiterAlertWppDesign from "./WaiterAlertWppDesign";
import React from 'react';

export default function WaiterDeliveryAlertWppModal({ 
  currentWppAlert,
  handleThrowoutHelpRequest,
  handleRedirectToWpp
}) {
  return <WaiterDeliveryAlertWppContainer 
    open={!!currentWppAlert?.type}
    toggle={() => handleThrowoutHelpRequest(currentWppAlert?.id)}
  >
    <WaiterAlertWppDesign
      currentWppAlert={currentWppAlert}
      handleThrowoutHelpRequest={handleThrowoutHelpRequest}
      handleRedirectToWpp={handleRedirectToWpp}
    />
  </WaiterDeliveryAlertWppContainer>
}